import Tracker from "./tracker";
import { type TrackerConfig } from "./tracker";
import { type TrackEvent } from "./monitoringItem/baseListener";
import integrations from "./monitoringItem";
import exts from "./ext";

export class Monitor {
  private static instances = new WeakMap<HTMLElement, Tracker>();
  static integrations: any = integrations;
  static exts: any = exts;
  static init(container: HTMLElement, options?: TrackerConfig) {
    let instance: any = null;
    instance = Monitor.instances.get(container);
    if (!instance) {
      instance = new Tracker(container,options);
      Monitor.instances.set(container, instance);
      console.log('Tracker initialized');
      // 页面卸载时
      window.addEventListener('beforeunload', () => {
        // console.log('beforeunload');
        instance?.destroy();
      });
      window.addEventListener('unload', () => {
        // console.log('unload');
        instance?.destroy();
      });
      window.addEventListener('pagehide', () => {
        // console.log('pagehide');
        instance?.destroy();
      });
      document.addEventListener("visibilitychange", function logData() {
        if (document.visibilityState === 'hidden') {
          // console.log('hidden');
          instance?.reportingDataLast();
        }
      });
    }
    return instance;
  }

  /**
   * 手动上报自定义事件
   * 用于非 DOM 交互触发的业务事件（如页面进入/离开）
   */
  static trackEvent(container: HTMLElement, event: Partial<TrackEvent>) {
    const instance = Monitor.instances.get(container);
    instance?.trackEvent(event);
  }

  /**
   * 手动上报自定义事件并立即 flush
   * 用于页面离开等需要立即发送的场景
   */
  static trackEventImmediate(container: HTMLElement, event: Partial<TrackEvent>) {
    const instance = Monitor.instances.get(container);
    instance?.trackEventImmediate(event);
  }
}
